module.exports = __webpack_public_path__ + "static/media/followup.f7c6cb11.png";